// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCzs0Z3nTFQEb0_Ez_bnXwlScDz4PvM9AE",
  authDomain: "car-parts-manufacturer-8d75b.firebaseapp.com",
  projectId: "car-parts-manufacturer-8d75b",
  storageBucket: "car-parts-manufacturer-8d75b.appspot.com",
  messagingSenderId: "411789579832",
  appId: "1:411789579832:web:6a70b7cd91b8d496f0f8cd"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth